import { JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const putAddTaskLock = async ({ taskId }: JsonDataItem) => {
  const data = await baseQuery('task/addsoftlock', {
    type: 'POST',
    body: {
      task_ID: taskId,
    },
  });

  return data;
};
